<!-- Loading -->
<ng-container *ngIf="(assignmentDetailsStateService.assignmentDetails | async) == null">
    <div class="text-center">
        <span><i class="fa-solid fa-spinner fa-spin"></i></span>
    </div>
</ng-container>

<ng-container *ngIf="(assignmentDetailsStateService.assignmentDetails | async) as details">
    <div class="d-flex flex-column gap-3">
        <!-- Detail -->
        <div>
            <!-- Information -->
            <div class="row">
                <div class="col-12 col-sm-6 mb-2">
                    <label>{{'assignments.information.eventNumber' | transloco}}</label>
                    <p>{{ details.number }}</p>
                </div>
                <div class="col-12 col-sm-6  mb-2">
                    <label>{{'assignments.information.sportType' | transloco}}</label>
                    <p>{{ details.sportName }}</p>
                </div>
                <div class="col-12 col-sm-6 mb-2">
                    <label>{{'assignments.information.courseTitle' | transloco}}</label>
                    <p>
                        {{ details.title }} 
                        <ng-container *ngIf="details.subEventTitle"> | {{ details.subEventTitle }}</ng-container>
                    </p>
                </div>
                <div class="col-12 col-sm-6 mb-2" *ngIf="details.level">
                    <label>{{'assignments.information.level' | transloco}}</label>
                    <p>{{ details.level }}</p>
                </div>
                <div class="col-12 col-sm-6 mb-2" *ngIf="details.level">
                    <label>{{'assignments.information.provSalary' | transloco}}</label>
                    <p>
                        <span *ngIf="details.provSalaryStatus == null">
                            {{'shared.swissFranc' |transloco}} {{ details.provSalary | number: '1.2-2'}}
                        </span>
                        <span *ngIf="details.provSalaryStatus != null">{{details.provSalaryStatus}}</span>
                        <span *ngIf="details.reasonForAbsence != null"> | {{details.reasonForAbsence}}</span>
                        <span *ngIf="details.isShortTimeWork"> | Kurzarbeit</span>
                    </p>
                    <p *ngIf="details.salaryDetails != null">{{details.salaryDetails}}</p>
                </div>
            </div>

            <!-- Date and Location -->
            <div class="row">
                <div class="col-12 col-sm-6 mb-2">
                    <!-- Column Headers -->
                    <label>{{'assignments.courseDates.date' | transloco}}</label>
                    <!-- Different Start and End Dates -->
                    <ng-container *ngIf="IsOnSameDay(details)">
                        <p>{{ details.from | date: "dd.MM.YY | HH:mm" }} - {{ details.to | date: "HH:mm" }}</p>
                    </ng-container>

                    <ng-container *ngIf="!IsOnSameDay(details)">
                        <p>{{ details.from | date: "dd.MM.YY | HH:mm" }} - {{ details.to | date: "dd.MM.YY | HH:mm" }}
                        </p>
                    </ng-container>
                </div>
                <div class="col-12 col-sm-6 mb-2" *ngIf="details.location != null">
                    <label>{{'assignments.courseDates.location' | transloco}}</label>
                    <p>{{details.location}}</p>
                </div>

                <div class="col-12 col-sm-6 mb-2" *ngIf="details.location == null">
                    <label>{{'assignments.courseDates.facilityRoom' | transloco}}</label>
                    <p *ngIf="!details.locations.length">-</p>
                    <p *ngFor="let location of details.locations">
                        {{ location.facility }} | {{ location.room }}
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-6 mb-2">
                    <label>{{'assignments.information.participantsCount' | transloco}}</label>
                    <p>
                        {{ details.participantsCount }}
                        {{'assignments.information.participantsCountFrom' | transloco}}
                        {{ details.maxParticipants }}
                    </p>
                </div>
            </div>
        </div>

        <div *ngIf="!details.isSubstituteSearch">
            <button (click)="openExchangeAssignmentModal()" class="btn btn-warning w-100">
                {{'assignments.information.exchangeAssignment' | transloco}}
            </button>
        </div>

        <div *ngIf="details.isSubstituteSearch">
            <button (click)="openCancellSubstituteSearchModal()" class="btn btn-warning w-100">
                {{'assignments.information.cancelSubstituteSearch' | transloco}}
            </button>
        </div>

        <div *ngIf="details.isCancelAllowed">
            <button (click)="openCancellationModal()" class="btn btn-danger w-100">
                {{'assignments.information.cancel' | transloco}}
            </button>
        </div>
    </div>
</ng-container>